__turbopack_context__.v({
  "container": "ChoiceInput-module__TCfXBG__container",
  "option": "ChoiceInput-module__TCfXBG__option",
  "optionTop": "ChoiceInput-module__TCfXBG__optionTop",
  "options": "ChoiceInput-module__TCfXBG__options",
});
